/**
 * @generated SignedSource<<06510e6f9b7decf60eeb581e53dcc91a>>
 * @relayHash ce238b9a592ae37635218ef3960b5bb3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ce238b9a592ae37635218ef3960b5bb3

import { ConcreteRequest } from 'relay-runtime';
export type ReferralReason = "APPOINTMENT_POST_REGISTRATION" | "APPOINTMENT_REGISTRATION" | "EMERGENCY_POST_REGISTRATION" | "EMERGENCY_REGISTRATION" | "REFERRAL";
export type ReferredBy = "CARE_PROVIDER" | "MEDGATE" | "SELF";
export type useReferredByReasonsQuery$variables = Record<PropertyKey, never>;
export type useReferredByReasonsQuery$data = {
  readonly ch_referredByReasons: ReadonlyArray<{
    readonly key: ReferredBy;
    readonly value: ReadonlyArray<ReferralReason>;
  }>;
};
export type useReferredByReasonsQuery = {
  response: useReferredByReasonsQuery$data;
  variables: useReferredByReasonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "KeyValuePairOfReferredByAndIReadOnlyCollectionOfReferralReason",
    "kind": "LinkedField",
    "name": "ch_referredByReasons",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useReferredByReasonsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useReferredByReasonsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "ce238b9a592ae37635218ef3960b5bb3",
    "metadata": {},
    "name": "useReferredByReasonsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "86517e058d21c660b05cca47a366ee1f";

export default node;
